import { UrlParams } from '@/types/fetch-options'

export const getRequestInit = (init?: RequestInit) =>
  ({
    ...init,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-validate': 'true',
      ...init?.headers,
    },
  }) satisfies RequestInit

export const getUrlWithParams = (url: string, params?: UrlParams) => {
  const [baseUrl, urlParams] = url.split('?')
  const searchParams = new URLSearchParams(urlParams)
  for (const [key, value] of Object.entries(params ?? {})) {
    if (Array.isArray(value)) {
      value.forEach((v) => searchParams.append(key, String(v)))
    } else {
      searchParams.set(key, String(value))
    }
  }
  return `${baseUrl}${searchParams.size > 0 ? `?${searchParams.toString()}` : ''}`
}
